/**
@prop --ux-input-unit-color: color of the unit text
@prop --ux-input-unit-padding: inner padding of the unit text
@prop --ux-input-unit-font-size: font-size of the unit text
@prop --ux-input-unit-font-weight: font-weight of the unit text
@prop --ux-input-unit-line-height: line-height of the unit text
 */
ux-input-field-number {
  box-sizing: border-box;
  display: block;
  margin: 0;
  max-width: 100%;
  position: relative;

  .ux-input-field-number__buttons {
    align-items: stretch;
    display: flex;
    flex-flow: row nowrap;
    height: 100%;
    justify-content: stretch;
  }
}
